import React from "react";
import ServiceAreaOneMultiImg from "./ServiceAreaOneMultiImg";
import { MECANICA_SERVICES_DATA } from "../data/mecanicaData";

// Icon mapping (default icons for services)
const defaultIcons = [
  "../assets/img/icon/service-icon_1-5.svg",
  "../assets/img/icon/process-icon-1-2.svg",
  "../assets/img/icon/service-icon_1-1.svg",
  "../assets/img/icon/service-icon_1-4.svg",
];

// Transform data from mecanicaData.js to the format expected by ServiceAreaOneMultiImg
const mecanicaServicesData = MECANICA_SERVICES_DATA.map((service, index) => ({
  icon: defaultIcons[index % defaultIcons.length],
  title: service.title,
  text: service.description.split('\n')[0].trim(), // First paragraph as summary
  link: `/mecanica/${service.slug}`,
  image: service.images?.[0] || "../assets/img/service/service-1-3.png",
  altIcon: `Icono ${service.title}`,
  altImage: `Imagen ${service.title}`,
}));

const MecanicaServicesData = ({ title }) => {
  return (
    <ServiceAreaOneMultiImg
      categoryService={title}
      services={mecanicaServicesData}
    />
  );
};

export default MecanicaServicesData;
